import Config from '../../config';
import fetch from '../../utils/fetchService';
import { handleErrors, parseAsJson } from '../../utils/requestHelpers';
import httpStatus from 'http-status-codes';
import ErrorsFactory from '../../utils/errorsFactory';
import BadRequestError from './badRequest.error';

export const fetchScenarios = () => fetch(
  Config.endpoints.FETCH_SCENARIOS
)
  .then(handleErrors({ errorMessage: 'Fetching scenarios failed' }))
  .then(parseAsJson);

export const disassociateCompanyCodeFromScenario = ({ scenarioId, companyCode }) => fetch(
  Config.endpoints.DISASSOCIATE_COMPANY_CODE_FROM_SCENARIO
    .replace(/:scenarioId/, scenarioId)
    .replace(/:companyCode/, companyCode),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Removing Company Code from scenario failed' }));

export const fetchScenarioData = ({
  reportName,
  scenarioId,
  companyCode = '',
  columns = [],
  reportingCurrency,
}) => fetch(
  Config.endpoints.FETCH_SCENARIO_CALC_DATA
    .replace(/:reportName/, reportName)
    .replace(/:scenarioId/, scenarioId)
    .replace(/:companyCodes/, `companyCodes[]=${companyCode}`)
    .replace(/:columns/, columns.join(','))
    .replace(/:reportingCurrency/, reportingCurrency)
)
  .then(handleErrors({ errorMessage: 'Fetching scenario calc data failed' }))
  .then(parseAsJson);

export const fetchScenarioCompareData = ({
  reportName,
  scenarioId,
  compareScenarioId,
  companyCode = '',
  columns = [],
  reportingCurrency,
}) => fetch(
  Config.endpoints.FETCH_SCENARIO_COMPARE_CALC_DATA
    .replace(/:reportName/, reportName)
    .replace(/:scenarioId/, scenarioId)
    .replace(/:compareScenarioId/, compareScenarioId)
    .replace(/:companyCodes/, `companyCodes[]=${companyCode}`)
    .replace(/:reportingCurrency/, reportingCurrency)
    .replace(/:columns/, columns.join(','))
)
  .then(handleErrors({ errorMessage: 'Fetching scenario calc data failed' }))
  .then(parseAsJson);

export const fetchScenarioReportFields = () => fetch(
  Config.endpoints.FETCH_SCENARIO_REPORT_FIELDS
)
  .then(handleErrors({ errorMessage: 'Fetching scenario report definition failed' }))
  .then(parseAsJson);

export const fetchCountries = () => fetch(
  Config.endpoints.FETCH_COUNTRIES
)
  .then(handleErrors({ errorMessage: 'Fetching countries failed' }))
  .then(parseAsJson);

export const createScenario = scenario => fetch(
  Config.endpoints.CREATE_SCENARIO,
  {
    method: 'POST',
    body: JSON.stringify(scenario),
  }
)
  .then(handleErrors({ errorMessage: 'Creating scenario failed' }));

export const updateScenario = scenario => fetch(
  Config.endpoints.UPDATE_SCENARIO
    .replace(/:scenarioId/, scenario.scenarioId),
  {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      scenarioName: scenario.scenarioName,
      enabledFlag: scenario.enabledFlag,
      publicFlag: scenario.publicFlag,
      lockedFlag: scenario.lockedFlag,
    }),
  }
)
  .then(handleErrors({ errorMessage: 'Saving scenario failed' }));


export const removeScenario = scenario => fetch(
  Config.endpoints.REMOVE_SCENARIO
    .replace(/:scenarioId/, scenario.scenarioId),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Removing scenario failed' }));


export const calculateScenario = scenarioId => fetch(
  Config.endpoints.CALCULATE_SCENARIO
    .replace(/:scenarioId/, scenarioId),
  {
    method: 'POST',
  }
)
  .then(handleErrors({ errorMessage: 'Calculating scenario failed' }));


export const updateScenarioReportValue = ({
  reportName,
  scenarioId,
  companyCode,
  countryTaxType,
  reportingCurrency,
  fieldName,
  value,
}) => fetch(
  Config.endpoints.UPDATE_SCENARIO_REPORT_VALUE
    .replace(/:scenarioId/, scenarioId)
    .replace(/:reportName/, reportName),
  {
    method: 'PUT',
    body: JSON.stringify({
      companyCode,
      countryTaxType,
      fieldName,
      value,
      reportingCurrency,
    }),
  }
)
  .then(handleErrors({ errorMessage: 'Updating scenario report value failed' }));

export const resetScenarioReportValue = ({
  reportName,
  scenarioId,
  companyCode,
  countryTaxType,
  fieldName,
}) => fetch(
  Config.endpoints.UPDATE_SCENARIO_REPORT_VALUE
    .replace(/:scenarioId/, scenarioId)
    .replace(/:reportName/, reportName),
  {
    method: 'DELETE',
    body: JSON.stringify({
      companyCode,
      countryTaxType,
      fieldName,
    }),
  }
)
  .then(handleErrors({ errorMessage: 'Resetting scenario report value failed' }));

export const uploadTaggedDataFile = async (scenarioId, formData) => await fetch(
  Config.endpoints.UPLOAD_SCENARIO_TAGGED_DATA
    .replace(/:scenarioId/, scenarioId), {
    method: 'POST',
    body: formData,
  }
)
  .then(response => {
    if (response.ok && (response.status >= httpStatus.OK && response.status < httpStatus.MULTIPLE_CHOICES)) {
      return response;
    }

    if (response.status === httpStatus.UNAUTHORIZED) {
      throw ErrorsFactory.UnauthorizedError('Uploading scenario tagged data failed');
    }

    if (response.status === httpStatus.BAD_REQUEST) {
      return parseAsJson(response)
        .then(responseError => {
          throw BadRequestError(
            'Uploading scenario tagged data failed',
            responseError && responseError.errors
          );
        });
    }

    throw ErrorsFactory.FetchingError('Uploading scenario tagged data failed', response.status);
  });

export const fetchAllowedPeriodsForScenarios = () => fetch(
  Config.endpoints.FETCH_ALLOWED_PERIODS_FOR_SCENARIOS
)
  .then(handleErrors({ errorMessage: 'Fetching allowed periods failed' }))
  .then(parseAsJson);
